module.exports = __webpack_public_path__ + "static/media/01_workshop_video.527c3ded.png";